import { useState } from "react";
import { X, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const inputCls = "w-full bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]";

export const ChangePassword = ({ testid = "change-password" }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("New passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated");
      setOpen(false);
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(formatApiError(err)); }
    setSaving(false);
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className="text-[10px] uppercase tracking-widest text-[#D4AF37] hover:text-[#F3D059] underline underline-offset-4 transition-colors duration-200" data-testid={testid}>
        Change your password
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center px-4" onClick={() => setOpen(false)} data-testid={`${testid}-modal`}>
          <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-[#0A0A0A] border border-white/10 p-8 w-full max-w-sm">
            <div className="flex justify-between items-start mb-6">
              <h2 className="font-heading text-xl font-black flex items-center gap-2"><KeyRound size={18} className="text-[#D4AF37]" /> Change Password</h2>
              <button type="button" onClick={() => setOpen(false)} className="text-white/50 hover:text-white"><X size={20} /></button>
            </div>
            <div className="space-y-3">
              <input required type="password" placeholder="Current password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className={inputCls} data-testid={`${testid}-current`} />
              <input required type="password" minLength={8} placeholder="New password (min 8)" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className={inputCls} data-testid={`${testid}-new`} />
              <input required type="password" minLength={8} placeholder="Confirm new password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className={inputCls} data-testid={`${testid}-confirm`} />
            </div>
            <button type="submit" disabled={saving} className="mt-5 w-full bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-6 py-3 rounded-sm hover:bg-[#F3D059] transition-colors duration-200 disabled:opacity-50" data-testid={`${testid}-save`}>
              {saving ? "Updating..." : "Update Password"}
            </button>
          </form>
        </div>
      )}
    </>
  );
};
